import { create } from 'zustand';

// Deliberately its own tiny store (not folded into uiModalStore) — this is a
// standalone, low-traffic notification independent of the auth/pricing modal
// lifecycle.
interface SignupBonusToastState {
  message: string | null;
  show: (message: string) => void;
  hide: () => void;
}

export const useSignupBonusToastStore = create<SignupBonusToastState>((set) => ({
  message: null,
  show: (message) => set({ message }),
  hide: () => set({ message: null }),
}));
